import { ProtocolError } from "../../validation/ProtocolError";

/**
 * Replay errors are explicit and typed.
 * We never want silent "best effort" correctness.
 */

export class ReplayCancelledError extends Error {
    public constructor(reason: string) {
      super(`Replay cancelled: ${reason}`);
      this.name = "ReplayCancelledError";
    }
  }
  
  export class UnknownEventTypeError extends ProtocolError {
    public readonly eventTypeName: string;
  
    public constructor(eventTypeName: string) {
      super(`Unknown event type: "${eventTypeName}"`);
      this.name = "UnknownEventTypeError";
      this.eventTypeName = eventTypeName;
    }
  }
  
  export class UnknownActionTypeError extends ProtocolError {
    public readonly actionTypeName: string;
  
    public constructor(actionTypeName: string) {
      super(`Unknown action type: "${actionTypeName}"`);
      this.name = "UnknownActionTypeError";
      this.actionTypeName = actionTypeName;
    }
  }